import { Component, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

import { SectionTitleComponent } from '../../shared/components/section-title/section-title.component';
import { MobileSectionTitleComponent } from '../../shared/components/mobile-section-title/mobile-section-title.component';
import { ArgumentBlock } from './argument-block/argument-block.component';
import { BtnToContactComponent } from '../../shared/components/btn-to-contact/btn-to-contact.component';

import { ScrollService } from '../../shared/services/scroll/scroll.service';
import { ContentService } from '../../shared/services/content/content.service';


@Component({
    selector: 'app-why-me',
    imports: [
    SectionTitleComponent,
    MobileSectionTitleComponent,
    ArgumentBlock,
    NgStyle,
    BtnToContactComponent
],
    templateUrl: './why-me.component.html',
    styleUrl: './why-me.component.scss',
})
export class WhyMeSection {
    @Input() whyMe!: any;


    constructor(private scrollService: ScrollService, public contentService: ContentService) { }


    triggerScroll(sectionId: string): void {   
        this.scrollService.requestScroll(sectionId);
    }
}
